export default {
  // 中文配置
  go_to_add: '开始添加',
  tips: '提示',
  title_no_env_desc: '此游戏暂不存在任何环境',
  has_been_opened: '已开通',
  click_btn_view_server: '你可以点击下面的按钮，在弹出窗口中查看并使用服务',
  get_started: '开始',
  create_new_env: '创建新环境',
  create_new_title: '创建新游戏',
  copy_clipboard: '已复制到剪贴板。',
  access_restricted_desc: '无法操作，您没有该权限',
  env_add_success: '环境添加成功。',
  env_add_fail: '添加环境失败',
  env_name_required: '环境名称是必填的',
  max_64: '最多限制64个字符。',
  only_letters_numbers: '支持字母、数字、下划线和中划线',
  name_exists_tips: '名称已存在',
  env_type: '环境类型',
  environment_name: '环境名称',
  add_environment: '创建环境',
  edit_environment: '修改环境',
  delete_title: '删除游戏',
  to_provide: '',
  env_table_id: 'ID',
  env_table_name: '名称',
  select_your_region: '请选择你的主站',
  env_type_required: '需要环境类型',
  select_your_env_type: '请选择你的环境类型',
  support_dev_desc: '目前仅支持创建开发环境，生产环境需要联系我们开放权限。',
  enter_environment_name: '请输入环境名称',
  enter_environment_desc: '请输入描述信息',
  env_del_success: '环境删除成功。',
  env_not_exist: '要删除的环境不存在',
  env_del_fail: '删除环境失败',
  migrate_game_confirm_has_service_desc:
    '环境：{{name}}中已启动服务。\n您确认删除此环境吗？此操作无法恢复。',
  migrate_game_confirm_desc: '您确定要删除环境：{{name}}吗？',
  del_environment: '删除环境',
  game_deleted_success_message:
    '{{gameName}}已成功删除！所有服务中的数据将在片刻后被删除',
  sure_del_title_desc: '您确定要删除：',
  sure_del_title_permanently_desc:
    '这将永久删除该游戏项目及其所有相关环境、配置和服务内数据',
  name_result_can_up_128: '结果名称可以长达128个字符，包括字母、数字和下划线。',
  // 同步：
  check_env: '检查环境',
  continue_anyway: '您是否仍然要继续？',
  lower_version_upgrade_desc:
    '您选择的目标环境版本低于原始环境版本，您需要在同步之前完成目标环境的升级（升级到与原始环境相同的版本）。',
  continue: '继续',
  config_sync: '配置同步',
  being_sync_desc: '配置正在同步中。',
  not_close_desc: '请稍候，不要关闭或刷新页面。',
  sync_success: '恭喜！环境同步已完成。',
  sync_fail: '同步操作失败，请重试。',
  sync_fail_contact: '同步操作失败，请联系开发人员。',
  operation_conflict_target: '操作冲突，目标环境有任务正在执行。',
  operation_conflict_org: '操作冲突，源环境有任务正在执行。',
  service_upgrade: '服务升级',
  upgrade_fail: '升级操作失败，请重试。',
  env_check_progress: '环境检查正在进行中。',
  env_check: '环境检查',
  synchronisation_failure: '同步失败',
  higher_version_failure_desc:
    '您选择的目标环境版本高于原始环境版本，您需要在同步之前完成原始环境的升级（升级到与目标环境相同的版本）。',
  missing_necessary_failure_desc:
    '内部错误,缺少必要的数据或配置,请联系InGame团队。',
  environment_sync: '环境同步',
  view_environment_sync_task: '查看环境同步任务',
  view_sync_task: '查看同步任务',
  full_replace: '全量覆盖',
  add_on: '增量追加',
  no_valid_service_version:
    '未检测到服务版本号（可能是存在环境未开通服务或已开通服务不支持环境同步功能），同步操作无法完成。请选择其他已开通服务的环境或联系平台开通服务后重试。',
  detected_incompatible_service_version:
    '检测到环境服务版本不一致，同步操作无法完成。请选择其他环境或联系平台升级版本后重试。',
  service_version_error: '错误',
  ds_sync_tips: '仅涉及Fleet Template配置',
  sync_method: '同步方法',
  sync_method_desc:
    '当前同步方法仅支持全量覆盖模式，即源环境所选服务的所有配置将会覆盖目标环境对应服务配置内容。如果配置存在关联关系，则关联内容也会一并进行同步。',
  go_view: '前往查看',
  task_submit_success: '任务提交成功',
  task_submit_success_tips: '环境同步任务提交成功，您可前往任务模块查看详情',
  env_sync_confirm_tips:
    '您确定要进行环境同步操作吗？该任务生成后无法撤销或回滚',
  sync_environment: '同步环境',
  no_services_synced: '没有可同步的服务',
  select_env: '选择环境',
  sync_config: '同步配置',
  org_env: '源环境',
  tar_env: '目标环境',
  select_services: '选择服务',
  select_one_service: '请选择至少一项服务',
  services_already_started_desc:
    '源环境与目标环境同时存在的服务才支持数据同步。',
  being_sync_not_close_page: '配置正在同步中，请不要关闭或刷新页面。',
  configuration_not_currently_services: '1. 目前不允许对单个服务进行配置同步。',
  build_packages_sync: '2. 构建包不在此次同步范围内。',
  verify_services_activated_both_desc:
    '请验证相应服务已在原始和目标环境中激活。',
  sync: '同步',
  edit_title_name_success: '编辑游戏名称成功！',
  edit_title_name_fail: '编辑游戏名称失败！',
  delete_title_desc: '点击“删除游戏”以删除游戏以及所有相关环境、配置和数据。',
  up_to_10_env: '每个游戏下最多10个环境。',
  up_to_30_env: '每个游戏下最多30个环境。',
  key: 'Key',
  value: 'Value',
  title_key: 'Title Key',
  after_service_activated_desc: '服务激活后，该字段将自动生成并显示',
  game_no_env_choose_again: '此游戏不再有环境，请重新选择。',
  basic: '基本信息',
  // features: '游戏配置',
  env_length: '业务环境({{envListLength}})',
  title_overview: '游戏概览',
  all_product: '所有产品',
  product_category: '产品类别',
  shortcuts: '快捷栏',
  request_fail_no_permission: '请求失败，可能因为没有这样的权限或服务错误。',
  game_not_env_tips: '当前游戏没有环境，请创建环境。',
  remove_favorites_success: '服务已成功从收藏中移除。',
  add_favorites_success: '服务已成功添加到收藏。',
  fail_application: '申请失败，未选择服务。',
  is_applying: ' 正在申请',
  is_opened: ' 已开通',
  application_success: '申请已成功发送，请耐心等待。',
  select_service_apply_for: '请选择您要申请的服务。',
  are_you_sure_apply_service: '您确定要申请服务吗？',
  sure_apply_this_service_desc: '您确定要申请激活此服务吗？',
  sure_apply_num_service_desc: '您确定要申请激活这些{{num}}个服务吗？',
  services: '服务',
  all_services_available: '所有服务均可用',
  batch_apply: '服务申请',
  more: '更多',
  received_application_24_hours: 'InGame已收到申请，将在48小时内完成审核。',
  service_close_tips: '该服务已关停，如有疑问请联系InGame团队',
  apply_to_start: '服务开通',
  ready_to_access: '准备访问',
  application_already_sent: '申请已发送 ({{services}})。',
  service_not_exist: '服务不存在。',
  apply_service_fail: '申请服务失败！',
  company_not_valid: '未完成企业认证',
  application_sent_success: '申请发送成功。',
  please_select_the_env: '请选择环境！',
  apply_service: '申请服务',
  latest_release: '最新发布：2025年1月17日',
  latest_version: '最新版本：V1.7.0',
  start_now: '立即开始',
  documentation: '文档',
  most_popular: '最受欢迎',
  new_release: '最新发布',
  step_check_env_desc:
    '每个游戏项目下至少存在一个业务环境，为了降低操作门槛，我们已为您创建了一个测试环境。请检查所有与环境相关的配置，这些参数需要填入SDK中。注意：只有在服务成功开通后，地址参数才会被返回。',
  check: '检查',
  step_apply_service_desc:
    '现在您可以申请开通感兴趣的服务进行体验，申请结果将在48小时内反馈。',
  step_sdk_contact_desc:
    'InGame 平台提供了完整的 SDK 和示例游戏。您可以直接下载 SDK，或使用我们的示例游戏快速了解服务功能特性。现在接入 InGame 服务，还可以获取示例游戏源码，提高服务接入效率。',
  contact_us_upper: '联系我们',
  go_to_download: '前往下载',
  step_obtain_configuration_information_desc:
    '在下载中心下载时，InGameSDK将自动注入游戏环境的配置信息，如需查看更多参数，可以前往游戏设置界面。',
  get: '查看配置',
  step_questions_contact_desc:
    '您已经完成InGame的基本配置内容，现在可以体验我们平台的功能服务，在使用过程中，如果您有任何问题或者建议，欢迎随时联系我们。',
  step_launched_help_desc:
    '如果您的游戏正在准备发布，请与我们联系。我们将为您准备充足的资源和专家团队支持以帮助您更好的完成上线前准备过程。',
  in_game_focus_on: 'InGame使开发者更专注于',
  innovation: '玩法创新',
  check_environment: '检查环境',
  sdk_download: 'SDK下载',
  get_configuration: '获取配置',
  testing: '测试',
  go_live: '上线',
  title_access_failed: '访问游戏失败。',
  devcloud_tips:
    '该服务暂不支持在DevCloud环境下操作，如果您对该服务感兴趣，请联系接口人切换体验环境。',
  novice_guide_btn: '了解',
  gamemode_desc:
    'Gamemode为游戏模式，用于承载不同的游戏玩法配置，在Matchmaking服务中可以参与匹配规则计算，在DS Hosting服务中，可以用于识别运行不同游戏玩法的 DS 集群，服务器将通过该配置来标识希望分配的 DS 类型。',
  party_desc:
    'Party为组队服务，它提供了一种玩家之间的临时的绑定关系，可以通过该服务在游戏中创建临时性的小队，支持玩家搜索加入、玩家邀请、请求加入、外链分享加入。',
  lobby_desc:
    'Lobby为大厅服务，它为玩家提供了一个临时的聚集场所，玩家可以通过该服务直接创建大厅，也支持Party服务经过匹配流程创建并加入Lobby。Lobby同时管理了大厅内的游戏对战信息，实现了对战DS的拉起、结算和游戏中途加入DS的信息同步等。',
  customtag_desc:
    'Custom Tags主要用于对战模块和DS服务，为匹配对战常规逻辑外的衍生规则配置，该Tag是一个请求相关联的自定义标签，可以用于匹配服务中的硬规则配置，也可以用于DS服务中通过该字段计算得出zone结果，进而指定选择不同的DSC来拉起。',
  please_select_open_service: '请选择要开通{{service}}下的服务（可多选）',
  automatically_open_service:
    '{{service}}服务需要与{{relevanceService}}服务配合使用，该服务将自动开通',
  apply_next_btn: '下一步',
  apply_submit_btn: '提交申请',
  apply_back_btn: '上一步',
  ingame_operation_tips:
    '该服务为InGame附加运营操作，无法单独使用，请确认需要执行命令行为的相关服务已完成接入',
  whether_name_unique_label: '玩家昵称Display Name是否唯一',
  whether_query_by_name_label: '是否需要支持玩家昵称Display Name检索',
  friend_type_label: '游戏的好友类型为：',
  account_friends: '游戏内账号好友',
  character_friends: '游戏内角色好友',
  qps_label: '预估登录峰值QPS',
  service_confirmation: '服务确认',
  information_filling: '信息填写',
  submit_applications: '提交申请',
  apply_complete_btn: '完成',
  apply_title: '{{service}}服务开通申请',
  apply_submit_tips:
    '{{service}} 服务开通申请已收到，InGame将在48小时内完成审核',
  puffer_apply_region: '服务大区',
  puffer_apply_southeast: '亚太东南大区',
  puffer_apply_japan: '亚太日本大区',
  puffer_apply_korea: '亚太韩国大区',
  puffer_apply_europe: '欧洲大区',
  puffer_apply_eastern: '北美美东大区',
  puffer_apply_western: '北美美西大区',
  puffer_apply_south: '南美大区',
  puffer_apply_singapore: 'InGame-新加坡大区',
  qps_placeholder: '请输入预估登录峰值QPS(整数)',
  can_not_apply_in_live: '正式环境暂不支持开通此服务',
  dmp_confirm_open_live:
    '确定要开通live环境的{{service}}吗？开通后，{{service}}将会开始收费，且dev环境的{{service}}将不可用，但数据仍将保留',
  dmp_nonsupport_open_dev: '已在live环境开通{{service}}，不可在dev环境开通',
  services_status_opened: '开启',
  services_status_closed: '关闭',
  services_status_geo: '开启（区域限制）',
  services_status_white: '开启（白名单访问）',
  services_status_tips_opened: '计划于{{time}}(UTC0)开服',
  services_status_tips_closed: '计划于{{time}}(UTC0)关服',
  services_status_tips_switch: '计划于{{time}}(UTC0)切换开服类型',
  view_plan: '查看计划',
  cancel_task: '取消任务',
  open_type: '开服类型',
  service_open: '开服',
  service_close: '关服',
  service_open_task: '开服任务提交',
  service_close_task: '关服任务提交',
  drawer_open_tips: '一旦选择了对应的开服类型，则无法变更，请谨慎操作',
  drawer_open_type_tips:
    '一旦选择了对应的开服类型，则开服后将按照对应类型进行限制，请谨慎操作',
  drawer_close_tips: '一旦开启关服流程，玩家将无法登录，请谨慎操作',
  drawer_env_info: '环境信息',
  switch_open_type: '切换开服类型',
  open_time: '开服时间(UTC0)',
  close_time: '关服时间(UTC0)',
  time_instant: '立即',
  time_scheduled: '定时',
  full_public_access: '公开访问',
  whitelist_access: '白名单访问限制',
  gro_restriction: '地区访问限制',
  view_whitelist: '查看白名单',
  task_status: '任务状态',
  cancellation_confirmation: '任务取消确认',
  cancellation_confirmation_tips:
    '该开服任务已经设定成功，是否确认取消该任务？',
  close_confirmation: '关服确认',
  close_confirmation_tips:
    '确认提交关服任务吗？如果关服任务开始执行，将会导致玩家无法登录，并且该任务将会在执行前 10 分钟进入预热阶段，此时任务将无法取消。',
  open_confirmation: '开服确认',
  open_confirmation_tips:
    '确认提交开服任务吗？如果开服任务开始执行，将会默认按照开服类型进行访问限制，并且该任务将会在执行前 10 分钟进入预热阶段，此时任务将无法取消。',
  view_opening_task: '查看开服任务',
  view_shutdown_task: '查看关服任务',
  view_task: '查看任务',
  no_change_disabled: '无开服类型变更，无法提交',
  version_too_low: '版本过低，不支持该功能',
  not_privacy_access: '由于未开通隐私服务，您当前无法设置该选项',
  task_cannot_cancel: '该任务已在执行中，无法取消',
  season_sync_tip: 'BattlePass配置依赖Season模块',
  gamemode_sync_tip: 'Matchmaker与SkillRating配置依赖Gamemode模块',
  factionset_sync_tip:
    'Matchmaker、SkillRating与Gamemode配置依赖FactionSet模块',
  coupled_with: '与 {{serviceName}} 耦合开通',
  coupling_tips:
    '由于部分服务之间存在耦合关系，当勾选此类服务时，存在耦合关系的其他服务也会被自动勾选开通',
  service_selection: '服务选择',
  service_application_tips: '此服务正在申请开通中，请耐心等待',
  exit_apply_tips: '确认要退出InGame服务申请吗？',
  exit_apply: '退出服务申请',
  select_apply_service: '已选择开通的服务：',
  related_matters_fill: '服务相关信息填写：',
  batch_apply_submit_tips: '你的服务开通申请已收到，InGame将在48小时内完成审核',
  not_support_dmp: '该服务暂不支持批量申请，请前往服务界面单独提交申请',
  game_code_exists: '该游戏代号已存在，无法创建',
  client_api_control: '客户端API管控',
  client_api: '客户端API',
  interface_description: '接口说明',
  permission_status: '访问权限状态',
  last_modified_by: '最后修改者',
  last_modified_time: '最后修改时间',
  unpublished_changes: '未发布的修改',
  discard_all: '放弃所有修改',
  api_publish: '发布',
  discard_changes: '放弃更改',
  discard_changes_tips: '您有未保存的更改，确认放弃所有更改吗？',
  api_cannot_be_disabled: '该接口不支持禁用',
  no_configurations_tips: '由于未开通{{serviceName}}服务，您当前无配置',
  go_to_apply: '前往开通',
  finally_released: '最后发布：',
  client_preview: '预览',
  client_preview_tips: '与上一版本进行比较',
  client_publish: '发布',
  client_publish_tips: '提交新版本',
  proceed_caution_tips:
    '发布后，已禁用API将导致客户端调用失败，可能影响线上业务，请谨慎操作。',
  version_info: '版本信息',
  version_name_tips:
    '新版本的名称可以包含多达128个字符，包括字母、数字和下划线，并且必须以字母开头。默认值是发布时间。',
  version_desc_tips: '新版本的描述，可以长达1024个字符。',
  version_name_validator: '必须由字母、数字、下划线组成，并且必须以字母开头。',
  version_name_required_validator: '名称 是必填项。',
  version_desc_validator: '最多输入1024个字符。',
  task_is_incomplete:
    '前序权限发布任务未完成或当前有正在进行中的开关服任务，请稍后再试',
  publish_confirm: '发布确认',
  confirm_changes_api_tips: '确认修改该API访问权限?',
  no_re_submission_tips:
    '该申请信息在游戏层级下管理，已存在其他环境填写过该信息，无需二次填写，如需修改请联系 InGame 团队',
  upgrade_version_tips: '当前版本暂不支持此功能，请升级至v1.10.0及以上版本',
  task_being_published: '此任务正在发布中，暂无法再次修改或放弃发布',
  publish_task_submit_success: '提交发布任务成功',
  currently_task_being_published: '当前存在正在发布中的任务，请耐心等待',
  service_not_deployed: '该服务未部署，无法进行客户端API权限管控',
  event_sync_tips: '仅涉及Custom Event配置',
  name_verification_failed: '游戏名称格式校验失败',
  client_api_sync_tips: '仅支持同步两个环境均开通的服务',
  statistics_sync_tips: 'Stats Event将关联同步',
  type_not_support_live: '该类型不支持创建 LIVE 环境',
  promo: '推荐',
  matchmaking_apply_tips: 'Matchmaking下的服务无法被单独开通',
  gauth_permission_activated: 'Store服务已开通，申请相关权限后即可使用。',
  gauth_permission_expired: 'Store服务已开通。相关权限已过期，请申请续期。',
  gauth_permission_apply: 'Store服务已开通。相关权限正在审批中，请耐心等候。',
  gauth_permission_apply_fail: 'Store服务已开通，相关权限申请失败。',
  gauth_permission_frozen:
    '因长期未访问Store服务，相关权限被冻结，请联系平台人工处理。',
  gauth_permission_denied: '本次权限申请被拒绝，请修改内容后重新提交。',
  platform_access_application: '平台权限申请',
  platform_selection: '平台选择',
  environment_details: '业务环境详情',
  creation_information: '创建信息',
  desc_information: '描述信息',
  export_environment_configuration: '导出环境配置',
  env_export_tips: '选择要导出的环境和服务配置，系统将生成加密的配置包',
  select_export_service: '选择导出服务',
  no_services_exported: '没有可导出的服务',
  verify_services_activated_desc: '请验证相应服务已在源环境中激活。',
  import_environment_configuration: '导入环境配置',
  game_time_setting: '时间设置',
  weekly_definition: '周定义',
  definition_st: '日',
  monday: '周一',
  tuesday: '周二',
  wednesday: '周三',
  thursday: '周四',
  friday: '周五',
  saturday: '周六',
  sunday: '周日',
  time_next: '下',
  monthly_definition: '月定义',
  next_monthly: '次月',
  current_monthly: '本月',
  effective_time_zone: '生效时区',
  effective_time_zone_desc:
    '该设置为游戏维度的时间基准。生效后，所有与本游戏配置相关的时间均按此时区规则执行，不受个人浏览器时区影响',
  system_settings: '系统设置',
  game_selection: '业务选择',
  role_selection: '角色选择',
  role_default_one: '外部平台产品 & 开发',
  role_default_two: '产品人员',
  application_duration: '申请时长',
  application_reason: '申请理由',
  enter_application_reason: '请输入申请理由',
  submit_application: '提交申请',
  one_click_renewal: '一键续期',
  game_default_one:
    '道聚城支撑系统（GMall / 北斗 / 海神 / 天秤 / 仓库 / 营销 / weLink）',
  game_default_two:
    '互娱 AMS 平台 - 营销活动系统 / 新闻广告系统 / 礼包道具仓库',
  one_month: '一个月',
  two_months: '两个月',
  three_months: '三个月',
  env_export_tips_desc:
    '导出的配置包将被加密处理，无法手动解压或修改。导入时会验证版本号和数据完整性',
  custom_data_tips: 'CustomData表仅支持导出Now版本',
  create_export_task: '创建导出任务',
  export_task_created_successfully: '导出任务创建成功',
  export_download_tips:
    '系统正在后台导出配置，完成后配置文件将可以从“审计中心”获取，',
  export_close_tips: '您可以关闭此窗口继续其他操作',
  go_to_view: '前往查看任务',
  task_id: '任务 ID',
  import_upload_exceed_tips: '上传的文件不能超过10M',
  fail_to_upload: '上传失败',
  uploading: '上传中...',
  file_check_tips: '文件已验证，加密签名正确',
  file_change: '更换',
  package_support: '仅支持 .enc 格式的加密配置包',
  drag_tips: '将文件拖拽至此，或点击',
  select_env_and_upload:
    '选择目标环境并上传配置包，系统将解析并导入配置，如果目标环境未开通相关服务，将会跳过对应服务的配置导入',
  upload_package: '上传配置包',
  package_info: '配置包信息',
  export_time: '导出时间',
  create_import_task: '创建导入任务',
  import_task_created_successfully: '导入任务创建成功',
  import_tips_one: '系统正在后台导入配置到目标环境，',
  import_close_tips: '您可以关闭此窗口继续其他操作',
  include_services: '包含服务',
  version_error_tips:
    '版本不匹配! 目标环境版本 ({{tarVersion}}) 与配置包版本 ({{orgVersion}}) 不一致，无法导入。',
  platform_accessns_submit: '平台权限申请已提交',
  platform_accessns_submit_renewal: '平台权限续期申请已提交',
  application_failed: '申请失败',
  daily_definition: '日定义',
  calendar_day: '自然日',
  custom_day: '自定义日',
  cross_day: '跨日',
  current_day: '当日',
  day_next: '次日',
  current_day_empyt: '当日',
  calendar_Week: '自然周',
  custom_week: '自定义周',
  current_week: '周内',
  cross_week: '跨周',
  current_week_empyt: '本',
  next_week: '下',
  calendar_month: '自然月',
  custom_month: '自定义月',
  cross_month: '跨月',
  time_current_month: '月内',
  time_month_next: '次月',
  time_month_current: '本月',
};
